import { render, staticRenderFns } from "./VContractForm.vue?vue&type=template&id=b0f98204&"
import script from "./VContractForm.vue?vue&type=script&lang=js&"
export * from "./VContractForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports